import { render, staticRenderFns } from "./PhotopointEdit.vue?vue&type=template&id=3ddd9e14&scoped=true&"
import script from "./PhotopointEdit.vue?vue&type=script&lang=js&"
export * from "./PhotopointEdit.vue?vue&type=script&lang=js&"
import style0 from "./PhotopointEdit.vue?vue&type=style&index=0&id=3ddd9e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd9e14",
  null
  
)

export default component.exports